import { Navigate } from "react-router-dom";
import { getToken } from "@/lib/utils";
import routes from "@/routes/routes";

// The only route allowed to match bare "/" — see routes/index.tsx for why
// that matters (a second competing match for "/" caused a logged-out user
// to land on `/dashboard` instead of `/login` after a forced logout).
const RootRedirect = () => {
  const isAuthenticated = !!getToken();

  return (
    <Navigate
      to={isAuthenticated ? routes.privateRoutes.DASHBOARD.path : routes.publicRoutes.LOGIN.path}
      replace
    />
  );
};

export default RootRedirect;
